import React from 'react';

function SupervisaoEscolar() {
    return (
        <div className="m-5 projetos-container">
            <h2>Supervisão em Psicologia Escolar</h2>
            <br></br>
            <p className="fw-bold">Apoio, Reflexão e Desenvolvimento Profissional</p>

            <span>A supervisão em Psicologia Escolar é um espaço essencial para o desenvolvimento de práticas críticas, éticas e eficazes no campo
                da educação. No Instituto Pasqualin, oferecemos supervisão especializada para psicólogos(as) que atuam ou desejam atuar em contextos
                escolares, com foco na promoção de práticas que enfrentem desigualdades e contribuam para uma educação inclusiva e
                transformadora.</span>

            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Objetivos da Supervisão</p>

            <ol>
                <li><strong>Aprofundar conhecimentos:</strong> Oferecer embasamento teórico e metodológico em Psicologia Escolar, dialogando com temas como saúde mental, diversidade, inclusão, direitos humanos e políticas públicas.</li>
                <li><strong>Fortalecer a prática profissional:</strong> Refletir sobre os desafios e dilemas enfrentados no cotidiano escolar, promovendo soluções criativas e embasadas.</li>
                <li><strong>Fomentar uma postura crítica:</strong> Identificar e questionar práticas e discursos que perpetuem desigualdades no ambiente escolar, promovendo mudanças alinhadas à justiça social.</li>
                <li><strong>Ampliar a rede de suporte:</strong> Criar um espaço colaborativo de troca de experiências e aprendizagens entre profissionais.</li>
            </ol>

            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Metodologia</p>

            <ul>
                <li><strong>Abordagem Reflexiva e Participativa:</strong> A supervisão é construída de forma dialogada, incentivando a troca de saberes e a reflexão sobre as práticas.</li>
                <li><strong>Casos Reais e Desafios Práticos:</strong> Análise de casos concretos trazidos pelos participantes, com foco em soluções aplicáveis e contextualizadas.</li>
                <li><strong>Teoria e Prática:</strong> Articulação de referenciais teóricos contemporâneos com as demandas do cotidiano escolar.</li>
                <li><strong>Perspectiva Interseccional:</strong> Sensibilidade às questões de gênero, raça, classe, diversidade sexual e outras marcantes no contexto escolar.</li>
            </ul>



            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Temas Abordados</p>

            <ul>
                <li><strong>Saúde Mental no Ambiente Escolar:</strong> Estratégias para acolhimento e cuidado de estudantes e educadores.</li>
                <li><strong>Inclusão e Diversidade:</strong> Trabalhar com crianças e adolescentes em situações de vulnerabilidade, com foco em práticas inclusivas e antidiscriminatórias.</li>
                <li><strong>Relação Escola-Família-Comunidade:</strong> Mediação de conflitos e fortalecimento de vínculos.</li>
                <li><strong>Intervenções Institucionais:</strong> Construção de estratégias de ação no âmbito da gestão escolar e das políticas educacionais.</li>
                <li><strong>Ética e Políticas Públicas:</strong> Reflexão sobre o papel do psicólogo escolar na implementação de políticas que garantam direitos educacionais.</li>
            </ul>


            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Para Quem?</p>

            <ul>
                <li><strong>Psicólogos(as) que atuam em escolas públicas ou privadas.</strong></li>
                <li><strong>Profissionais que estão iniciando na área da Psicologia Escolar.</strong></li>
                <li><strong>Psicólogos(as) que desejam aprimorar práticas já existentes ou expandir sua compreensão sobre o campo educacional.</strong></li>
                <li><strong>Estudantes de Psicologia que buscam maior aprofundamento teórico e prático na área.</strong></li>
            </ul>


            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Formato e Estrutura</p>

            <ul>
                <li><strong>Encontros:</strong> Supervisões realizadas em formato individual ou em grupo, presenciais ou online.</li>
                <li><strong>Duração:</strong> Sessões de 1h30min, com frequência definida conforme a necessidade do profissional ou grupo.</li>
                <li><strong>Facilitadores:</strong> Supervisores com ampla experiência na área de Psicologia Escolar e Educacional, comprometidos com práticas críticas e emancipatórias.</li>
            </ul>


            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Por que escolher a Supervisão no Instituto Pasqualin? </p>

            <ul>
                <li><strong>Compromisso Ético-Político:</strong> Nosso trabalho é pautado na defesa de uma educação inclusiva e no combate às desigualdades.</li>
                <li><strong>Pluralidade Epistemológica:</strong> Integramos diferentes perspectivas teóricas para enriquecer a prática profissional.</li>
                <li><strong>Foco na Transformação Social:</strong> Buscamos capacitar profissionais que atuem como agentes de mudança no ambiente escolar.</li>
            </ul>


            <br></br>
            <hr></hr>
            <br></br>
            <p className="fw-bold">Entre em Contato</p>

            <span>Se você deseja refletir, aprimorar sua prática e atuar de forma mais crítica e eficaz no campo da Psicologia Escolar,
                nossa supervisão é o espaço ideal para o seu desenvolvimento.</span>
            <p className="mt-1 fw-bold">Junte-se a nós na construção de uma educação mais inclusiva, justa e transformadora!</p>


        </div>
    );
}

export default SupervisaoEscolar;
